import React, { useEffect, useState } from 'react';
import { Container, Table, Badge, Button, Spinner, Form, Row, Col } from 'react-bootstrap';
import { ordersAPI } from '../../services/api';
import { toast } from 'react-toastify';
import AdminLayout from '../../components/AdminLayout';

const Orders = () => {
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filters, setFilters] = useState({
    paymentStatus: '',
    deliveryStatus: '',
  });

  useEffect(() => {
    fetchOrders();
  }, [filters]);

  const fetchOrders = async () => {
    try {
      const response = await ordersAPI.getAll(filters);
      setOrders(response.data.orders);
    } catch (error) {
      toast.error('Failed to load orders');
    } finally {
      setIsLoading(false);
    }
  };

  const handleRetryDelivery = async (orderId) => {
    try {
      await ordersAPI.retryDelivery(orderId);
      toast.success('Delivery retry initiated');
      fetchOrders();
    } catch (error) {
      toast.error('Failed to retry delivery');
    }
  };

  const getStatusBadge = (status) => {
    const variants = {
      completed: 'success',
      pending: 'warning',
      failed: 'danger',
      refunded: 'info',
      sent: 'success',
    };
    return <Badge bg={variants[status] || 'secondary'}>{status}</Badge>;
  };

  return (
    <AdminLayout>
    <Container fluid className="my-4">
      <h1 className="mb-4">Order Management</h1>

      <Row className="mb-4">
        <Col md={4}>
          <Form.Group>
            <Form.Label>Payment Status</Form.Label>
            <Form.Select
              value={filters.paymentStatus}
              onChange={(e) => setFilters({ ...filters, paymentStatus: e.target.value })}
            >
              <option value="">All</option>
              <option value="completed">Completed</option>
              <option value="pending">Pending</option>
              <option value="failed">Failed</option>
              <option value="refunded">Refunded</option>
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group>
            <Form.Label>Delivery Status</Form.Label>
            <Form.Select
              value={filters.deliveryStatus}
              onChange={(e) => setFilters({ ...filters, deliveryStatus: e.target.value })}
            >
              <option value="">All</option>
              <option value="sent">Sent</option>
              <option value="pending">Pending</option>
              <option value="failed">Failed</option>
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      {isLoading ? (
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>Order ID</th>
              <th>Customer</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Amount</th>
              <th>Payment</th>
              <th>Delivery</th>
              <th>Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order) => (
              <tr key={order._id}>
                <td><small>{order._id.slice(-8)}</small></td>
                <td>{order.userId?.name || order.customerInfo?.name}</td>
                <td>{order.customerInfo?.email}</td>
                <td>{order.customerInfo?.phone || 'N/A'}</td>
                <td>₹{order.totalAmount}</td>
                <td>{getStatusBadge(order.paymentStatus)}</td>
                <td>
                  {getStatusBadge(order.deliveryStatus)}
                  <div className="mt-1">
                    {order.emailSent && <Badge bg="success" className="me-1 small">Email</Badge>}
                    {order.whatsappSent && <Badge bg="success" className="small">WA</Badge>}
                  </div>
                </td>
                <td>{new Date(order.createdAt).toLocaleDateString()}</td>
                <td>
                  {order.paymentStatus === 'completed' && order.deliveryStatus !== 'sent' && (
                    <Button
                      size="sm"
                      variant="warning"
                      onClick={() => handleRetryDelivery(order._id)}
                    >
                      Retry Delivery
                    </Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </Container>
    </AdminLayout>
  );
};

export default Orders;
